import { Component, OnInit, Input } from '@angular/core';
import { NbAuthService, NbAuthResult } from '@nebular/auth';
import { Router } from '@angular/router';
import { UserModel } from 'src/app/core/models/user.model';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/core/services/user.service';
import { takeWhile } from 'rxjs/operators';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'dum-header-private',
  templateUrl: './header-private.component.html',
  styleUrls: ['./header-private.component.scss']
})
export class HeaderPrivateComponent extends BaseComponent implements OnInit {

  @Input() user: UserModel;
  userLogueado: UserModel = new UserModel();
  imgCencyl: string;
  imgInterreg: string;
  imgDuminval: string;
  constructor(
    private authService: NbAuthService,
    private router: Router,
    private translateService: TranslateService,
    private userService: UserService,
  ) {
    super();
    this.imgCencyl = environment.logo_cencyl;
    this.imgInterreg = environment.logo_interreg;
    this.imgDuminval = environment.logo_duminval;
    this.userService.findMe()
      .pipe(takeWhile(() => this.alive))
      .subscribe((user) => this.userLogueado = user);
   }

  ngOnInit(): void {
  }

  logout() {
    this.router.navigate(['/area-privada/logout']);
  }
}
